export default {"src":"/_next/static/media/recieved.a4acda23.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};